// extracted by mini-css-extract-plugin
module.exports = {"swatch":"_2rhOFuK"};